/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ onClick, tabIndex }) => (
    <button type="button" className='dashboard-btn dashboard-btn-submit' onClick={onClick} tabIndex={tabIndex}>
        OK
    </button>
);

Button.propTypes = {
    onClick: PropTypes.func.isRequired,
    tabIndex: PropTypes.number,
};

Button.defaultProps = {
    tabIndex: 0,
};

export default Button;
